import { CircleExclamation } from '@kvika/audur-icons'
import { PrismicRichText } from '@prismicio/react'

import { SiteAlert as SiteAlertType } from '../../utils/types/Types'

import styles from './SiteAlert.module.scss'
import { getSupportedAlertBody, isTrustedAlertUrl } from './siteAlertContent'

type Props = {
	alert: NonNullable<SiteAlertType>
}

const SiteAlert = ({ alert }: Props) => {
	const body = alert.body && getSupportedAlertBody(alert.body)
	return (
		<div className={styles.siteAlert} role='alert' data-testid='site-alert'>
			<div className={styles.inner}>
				<span className={styles.icon} aria-hidden>
					<CircleExclamation />
				</span>
				<div className={styles.text}>
					{alert.title && <p className={styles.title}>{alert.title}</p>}
					{body && (
						<div className={styles.body}>
							<PrismicRichText
								field={body}
								components={{
									// Untrusted links keep their text but lose the link
									hyperlink: ({ node, children, key }) => {
										const url = 'url' in node.data ? node.data.url : undefined
										return isTrustedAlertUrl(url) ? (
											<a key={key} href={url}>
												{children}
											</a>
										) : (
											<span key={key}>{children}</span>
										)
									},
								}}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export default SiteAlert
